let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jTZeb")).then(() => parcelRequire('8QCI8'));